<template>
    <div class="congratulations_on_becoming">
        <!-- <div class="title">恭喜你成为{{vipName}}会员</div> -->
        <div class="success_box">
            <img src="./img/payImg/up_success_img.png" class="success_detail_img" alt="">
            <img src="./img/payImg/yhyouhui.gif" class="success_detail_yhyouhui success_detail_yhyouhui_left" alt="">
            <img src="./img/payImg/yhyouhui.gif" class="success_detail_yhyouhui success_detail_yhyouhui_right" alt="">
            <div class="success_detail">
                <div class="success_detail_title">恭喜您，成功升级为 <span class="vip_name">{{userInfo.vip_name}}</span></div>
                <div class="success_detail_time">
                    会员有效期至：{{ userInfo.vip_end_date }}
                </div>
                <div class="success_detail_tips">
                    感恩有你！感谢您加入我们的大家庭
                </div>

            </div>
            <div class="ok_know" @click="handleClick">
                好的，我知道了
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed:{
            userInfo() {
                return this.$store.state.userInfo;
            },
        },
        methods: {
            // 点击跳领取优惠券
            handleClick() {
                // 点击跳领取优惠券关闭当前弹窗
                this.$store.commit("setVipCongratulationsShow",false);
            }
        }

    }
</script>

<style lang="scss" scoped>
.congratulations_on_becoming{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    .success_box{
        transform-origin: center;
        /* 设置缩放中心点为元素中心 */
        animation: scaleIn 1s ease-out forwards;
        position: relative;
        z-index: 3;
        .success_detail_img{
            width: calc(100% - 30px);
            height: 334px;
            display: block;
            margin: 0 auto;
        }
        .success_detail_yhyouhui{
            position: absolute;
            z-index: -1;
            top: -120px;
            width: 200px;
            height: auto;
            opacity: 0.3;
        }
        .success_detail_yhyouhui_left{
            left: 0px;
        }
        .success_detail_yhyouhui_right{
            right: 0px;
            transform: scaleX(-1)
        }
        .success_detail{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 100px;
            width: calc(100% - 60px);
            // height: 271px;
            // background: #ccc;
            text-align: center;
            .success_detail_title{
                color: #ebd6b2;
                font-size: 18px;
                margin-top: 25px;
                font-weight: 600;
                .vip_name{
                    color: transparent;
                    background-image: linear-gradient(to right, #ff9d8e, #b36fdd);
                    -webkit-background-clip: text;
                    background-clip: text;
                }
            }
            .success_detail_time{
                color: #999;
                font-size: 14px;
                margin-top: 25px;
            }
            .success_detail_tips{
                color: #dfcba9;
                font-size: 14px;
                margin-top: 25px;
            }
        }
            .ok_know{
                color: #5e441a;
                font-weight: 600;
                font-size: 14px;
                margin-top: 30px;
                width: calc(100% - 70px);
                height: 60px;
                // background: #ccc;
                // line-height: 60px;
                cursor: pointer;
                position: absolute;
                bottom: 15px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }
    @keyframes scaleIn {
        0% {
        transform: scale(0);
        /* 开始时完全缩小 */
        opacity: 0;
        /* 可选：开始时完全透明 */
        }

        100% {
        transform: scale(1);
        /* 结束时正常大小 */
        opacity: 1;
        /* 可选：结束时完全不透明 */
        }
    }
}
</style>